<template>
  <div class="Search clear-fix">
    <div class="Search-input">
      <a-input :placeholder="placeholder" v-model="searchText" allowClear>
        <a-icon slot="prefix" type="search" />
      </a-input>
    </div>
    <a-button class="search-btn"  @click="searchClick">搜索</a-button>


  </div>
</template>

<script>

export default {
  name: "Search",
  props: {
    placeholder: {
      type: String,
      default() {
        return "请输入搜索内容"
      }
    }
  },
  data() {
    return {
      searchText: ''
    }
  },
  methods: {
    searchClick() {
      this.$emit("onSearch", this.searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
  .Search {
    .Search-input {
      width: 250px;
      margin: 0 15px 0 0px;
      float: left;
    }
    .search-btn {
      float: left;
      color: #fff;
      background-color:rgba($color: #E84D11, $alpha: .6)
    }
  }

</style>
